import * as React from "react";
import { AppBar } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Typography from "@material-ui/core/Typography";
import { InvoiceStatusSection } from "./InvoiceStatusSection";
import { useBackOr } from "../../hooks/useInAppHistory";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import { InvoiceStatusPill } from "./InvoiceStatusPill";
import { Contact } from "../../generated/nest-graphql";

export const InvoiceDetailsAppBar: React.FC<{
  invoiceNumber: string;
  status: string;
  invoiceId: string;
  contactId: string;
  payer: string;
  amount: string;
  balanceDue: string;
  laborCost: string;
  partsCost: string;
  partsTax: string;
  laborTax: string;
  totalTax: string;
  subTotal: string;
  refetch: any;
  jobId: string;
  checkListsCreated: boolean;
  contact: Contact;
  amountPaid: string;
  proceedingWithRepairs?: boolean;
  onCloseJobSuccess: () => void;
  /** VEHICLE-HISTORY beta: the status in the header and the job page's action row. */
  statusInHeader?: boolean;
}> = ({
  invoiceNumber,
  status,
  invoiceId,
  payer,
  contactId,
  amount,
  balanceDue,
  refetch,
  laborCost,
  partsCost,
  partsTax,
  laborTax,
  subTotal,
  totalTax,
  jobId,
  checkListsCreated,
  contact,
  amountPaid,
  proceedingWithRepairs,
  onCloseJobSuccess,
  statusInHeader,
}) => {
  // Opened directly (a link, a reload), the invoice's own job is the natural way back.
  const goBack = useBackOr(jobId ? `/jobs/${jobId}` : "/");
  return (
    <AppBar position={"sticky"}>
      <Toolbar>
        <IconButton
          onClick={goBack}
          aria-label="Back"
          edge={statusInHeader ? "start" : false}
          style={statusInHeader ? { padding: 10, marginRight: -8 } : undefined}
        >
          <ArrowBackIosIcon />
        </IconButton>
        {statusInHeader && <ReceiptOutlinedIcon style={{ marginRight: 6, flexShrink: 0 }} />}
        <Typography
          variant="h6"
          noWrap={statusInHeader}
          style={statusInHeader ? { minWidth: 0, marginRight: 8 } : undefined}
        >
          {`Invoice: ${invoiceNumber}`}
        </Typography>
        {statusInHeader && <InvoiceStatusPill status={status} className="ml-auto" />}
      </Toolbar>
      <InvoiceStatusSection
        laborCost={laborCost}
        payer={payer}
        partsCost={partsCost}
        partsTax={partsTax}
        laborTax={laborTax}
        subTotal={subTotal}
        totalTax={totalTax}
        status={status}
        invoiceId={invoiceId}
        contactId={contactId}
        amount={amount}
        balanceDue={balanceDue}
        refetch={refetch}
        jobId={jobId}
        checkListsCreated={checkListsCreated}
        contact={contact}
        amountPaid={amountPaid}
        proceedingWithRepairs={proceedingWithRepairs}
        onCloseJobSuccess={onCloseJobSuccess}
        hideStatus={statusInHeader}
      />
    </AppBar>
  );
};
